import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  headerStyle: {
    height: 12.5,
    marginHorizontal: 2,
  },
  headerContainerStyle: {
    marginTop: Platform.OS === 'ios' ? 27 : 17,
  },
  subHeaderStyle: {
    height: 12.5,
    marginHorizontal: 2,
  },
  subheaderContainerStyle: {
    marginTop: 37.4,
    marginBottom: 25,
  },
  tabItemStyle: {
    width: 69,
    height: 33.3,
    borderRadius: 16.6,
    marginRight: 12,
  },
  tabsContainerStyle: {
    marginBottom: 30,
    marginHorizontal: 2,
  },
  titleStyle: {
    height: 13,
  },
  dateStyle: {
    marginTop: 34,
    width: '77%',
    height: 13,
  },
  usageStyle: {
    marginTop: 31.2,
    height: 13,
  },
  totalStyle: {
    height: 13,
    marginTop: 21,
  },
  graphStyle: {
    height: 222,
    width: '100%',
    marginTop: 17,
  },
  usageBodyOnlyItemContainer: {
    marginTop: 18,
  },
  usageBodyItemContainer: {
    marginTop: 25,
  },
  usageBodyItemCircle: {
    width: 34,
    height: 34,
    borderRadius: 6.2,
    marginRight: 17,
    marginTop: 5,
  },
  usageBodyItemSquare: {
    marginTop: 5,
    width: '100%',
    height: 14,
  },
  separator: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: 25,
  }),
  separatorTwo: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: 16,
  }),
});
